import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/en';
export const locale = {
  lang: 'de',
  data: {
    'ODS': {
      'TITULO': 'Unternehmensprofil',
      'TOOLBAR': {
        'NUEVA': 'Erstellen Sie das Profil für ein Unternehmen',
        'EDITAR': 'Sie können die Profildaten dieser Firma ändern',
        'CAMBIOS': '(Änderungen werden automatisch gespeichert)',
        'DESCARGAR': 'Unternehmensinformationen herunterladen'
      },
      'FORMULARIOS': {
        '0': 'Firmeninformation',
        '1': 'Projektmanager',
        '2': 'Leiter der Personalabteilung',
        '3': 'IT-Manager',
      },
      'BOTONES': {
        'BACK': 'Vorherige',
        'NEXT': 'Nächste',
        'ACEPTAR': 'Annehmen'
      },
      'MODALES': {
        'EMPRESA_EXISTE': 'Es gibt bereits eine registrierte Firma mit dem angegebenen Namen, versuchen Sie die Firma erneut mit einem anderen Namen zu erstellen',
        'ERROR_GUARDADO': 'Beim Erstellen des Unternehmens ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut',
        'GUARDANDO': 'Änderungen speichern',
        'GENERANDO_PDF': 'PDF-Datei wird generiert, warten Sie einen Moment'
      },
      'CAMPOS': {
        'institutoEmpresa': 'Makler',
        'country_application': 'Land des Maklers',
        'nombreEmpresa': 'Gesellschaft',
        'shortName': 'Firmenkurzname',
        'nombrePublicacion': 'Firmenname zur Veröffentlichung',
        'account_id': 'Konto-ID',
        'idSalesForce': 'SalesForce-ID',
        'codigoProyecto': 'Projektnummer',
        'anioFundacion': 'Gründungsjahr',
        'empleadosCompleto': 'Vollzeit-Angestellte',
        'empleadosParcial': 'Teilzeitbeschäftigte',
        'totalColaboradores': 'Gesamtzahl der Mitarbeiter',
        'sector': 'Wählen Sie einen Sektor',
        'subSector': 'Wählen Sie einen Untersektor',
        'multinacional': 'Multinational',
        'name_multinational_group':'Name der multinationalen Gruppe',
        'region': 'Wählen Sie eine Region',
        'pais': 'Land',
        'estado': 'Bundesland, Stadt oder Provinz',

        'nombreResponsable': 'Name',
        'apellidoResponsable': 'Nachname',
        'emailResponsable': 'Email',
        'telResponsable': 'Telefon',
        'extResponsable': 'Verlängerung',
        'celResponsable': 'Handy, Mobiltelefon',

        'nombreRH': 'Vollständiger Name',
        'emailRH': 'Email',
        'telRH': 'Telefon',
        'extRH': 'Verlängerung',
        'celRH': 'Handy, Mobiltelefon',

        'nombreTI': 'Vollständiger Name',
        'emailTI': 'Email',
        'telTI': 'Telefon',
        'extTI': 'Verlängerung',
        'celTI': 'Handy, Mobiltelefon',

        'PDF_sector': 'Sektor',
        'PDF_subSector': 'Teilsektor',
        'PDF_region': 'Region',
        'PDF_fecha': 'Datum:',
        'PDF_hora': 'Stunde:',
      },
      'CATALOGOS': {
        'institutoEmpresa': catalogos.institutos,
        'sector': catalogos.sectores,
        'region': catalogos.regiones,
        'multinacional': {
          '1': 'Jawohl',
          '2': 'Nein',
        }
      },
      'ERRORES': {
        'minlength': 'Sie haben nicht die zulässige Mindestanzahl von Zeichen eingegeben',
        'maxlength': 'Sie haben die maximal zulässige Anzahl von Zeichen überschritten',
        'max': 'Die eingegebene Zahl überschreitet das zulässige Maximum',
        'min': 'Die eingegebene Zahl ist kleiner als das erforderliche Minimum',
        'pattern': 'Der eingegebene Text enthält in diesem Feld nicht zulässige Zeichen',
        'email': 'Der eingegebene Text hat nicht das richtige E-Mail-Format',
        'required': 'Dieses Feld wird benötigt',
        'TEXT_ESPEC_ANIOFUNDA':'Das eingegebene Datum überschreitet den zulässigen Höchstwert',
      }
    }
  }
};
